module.exports = __webpack_public_path__ + "img/__publicidad.ddb29e19.png";